var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-root"},_vm._l((Array(12)),function(_,key){return _c('div',{key:key,staticClass:"spinner-element"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }